module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#cricket",
      toString: function () {
        return this.url;
      }
    }